module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "id": "app",
      "toolbar": "",
      "footer": "",
      "fixed-footer": ""
    }
  }, [_c('v-navigation-drawer', {
    staticClass: "pb-0",
    attrs: {
      "persistent": "",
      "clipped": "",
      "enable-resize-watcher": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_c('v-list-tile', {
    attrs: {
      "to": {
        name: 'home'
      },
      "exact": ""
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("home")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("主页")])], 1)], 1), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "to": {
        name: 'favorites'
      }
    }
  }, [_c('v-list-tile-action', [_c('v-icon', [_vm._v("favorite")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v("收藏的歌")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-toolbar', {
    staticClass: "main-navbar teal lighten-2",
    attrs: {
      "fixed": "",
      "dark": ""
    }
  }, [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', [_vm._v("Vue Music Box")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('music-search-box'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "to": {
        name: 'favorites'
      },
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("favorite")])], 1)], 1), _vm._v(" "), _c('main', [_c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('v-footer', {
    staticClass: "grey darken-3",
    attrs: {
      "dark": "",
      "fixed": ""
    }
  }, [_c('music-player')], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-422fecc5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 148
// module chunks = 1